import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=67c0c780&scoped=true&"
import script from "./CallUs.vue?vue&type=script&lang=js&"
export * from "./CallUs.vue?vue&type=script&lang=js&"
import style0 from "./CallUs.vue?vue&type=style&index=0&id=67c0c780&prod&lang=css&"
import style1 from "./CallUs.vue?vue&type=style&index=1&id=67c0c780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0c780",
  null
  
)

export default component.exports